import axios from "axios";
import { get, post } from "../../utils/api";
import { ASSESSMENT, ASSESSMENT_URL } from "../../utils/url-builder";
import BaseService from "./base.service";

class KnowledgeService extends BaseService {
    constructor() {
        super(ASSESSMENT_URL);
        this.route = "knowledgeScore/";
    }

    getReport(studentId, nodeId) {
        return new Promise(async (resolve, reject) => {
            try {
                const query = nodeId ? { studentId, nodeId } : { studentId };
                const res = await this.makeGetRequest(this.route + "getReport", {
                    ...query
                });

                return resolve(res);
            } catch (error) {
                //reject(error);
                console.log(error);
            }
        });
    }


}

const knowledgeService = new KnowledgeService();
export default knowledgeService;
